<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.user }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaKaryawan="{ item }">
                <td>
                  <span style="cursor: pointer" @click="$router.push(`/detailKaryawan?dataKaryawanId=${item.datakaryawanid}`)">{{ item.namaKaryawan }}</span>
                </td>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    :disabled="item.username == 'super_admin' && !supers"
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="data = item"
                    ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
                  >
                  <b-button
                    :disabled="item.username == 'super_admin' && !supers"
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                    ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                  >
                  <b-button :disabled="item.username == 'super_admin' && !supers" variant="info" v-c-tooltip.hover.click="'Reset Password'" v-b-modal.modal-reset @click="data = item"
                    ><CIcon name="cil-star" /> {{ item.actions }}</b-button
                  >
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input :divisi="divisi" :listMitra="listMitra" :listKaryawan="listKaryawan" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :listMitra="listMitra" :listKaryawan="listKaryawan" :divisi="divisi" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" :divisi="divisi" @alertFromChild="triggerAlert($event)" />
    <modal-reset :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
import modalReset from "./modalReset.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
    modalReset,
  },
  name: "user",
  data() {
    return {
      divisi: [],
      listMitra: [],
      listKaryawan: [],
      data: {},
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "username",
          label: "Username",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "email",
          label: "Email",
          _style: "width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: "Nama",
          _style: "max-width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "NIP",
          label: "NIP",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        // {
        //   key: "namaPosisi",
        //   label: "Posisi",
        //   _style: "width: 10%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 15%;",
          filter: false,
          sorter: false,
        },
      ],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    supers() {
      return this.$store.state.role_aktif.kodeRole == "super";
    },
  },
  mounted() {
    const vm = this;
    if (vm.supers) {
      vm.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    console.log(vm.$store.state);
    vm.getDatas();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      //user
      let listUser = await vm.$axios.post("user/ALLPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      //console.log("listUser", listUser);
      vm.items =
        listUser.data.status == 200
          ? listUser.data.data.map((x, idx) => {
              return {
                ...x,
                masterDivisiId: x.masterDivisiIdUser,
                id: x.masterUserId,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                namaMitra: x.namaMitra || " - ",
                nama: x.nama || " - ",
                NIP: x.NIP || " - ",
                //edit
                mitra: x.mitraId ? { id: x.mitraId, namaMitra: x.namaMitra } : null,
                karyawan: x.dataKaryawanId ? { id: x.dataKaryawanId, namaKaryawan: x.namaKaryawan } : null,
              };
            })
          : [];
      // console.log("vm.listUser", vm.items);
      vm.totalRows = parseInt(listUser.data.count);
      vm.loading = false;

      //divisi
      let divisi = await vm.$axios.post("masterDivisi/list");
      vm.divisi =
        divisi.data.status == 200
          ? divisi.data.data.map((x) => {
              return {
                ...x,
                id: x.masterDivisiId,
                value: x.masterDivisIid,
                text: x.namaDivisi,
              };
            })
          : [];

      let listMitra = await vm.$axios.post("mitra/listPerHalaman", {
        halaman: 0,
        jumlah: 100,
      });
      // console.log('listMitra', listMitra)
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];

      let listKaryawan = await vm.$axios.post("dataKaryawan/listKaryawanBelumPunyaUser");
      // console.log("listKaryawan", listKaryawan);
      vm.listKaryawan =
        listKaryawan.data.status == 200
          ? listKaryawan.data.data.map((x) => {
              return {
                ...x,
                id: x.dataKaryawanId,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
